import React from "react";
import Navbar from "../../../components/Navbar";
import BackToTop from "../../../components/BackToTop";
import { Container, NavbarGroup, Content } from "../style";

const TermoCienciaNRF = () => {
  return (
    <Container>
      <Container id="back-to-top-anchor" />
      <Navbar />

      <NavbarGroup aria-label="Conteúdo da página">
        <p>Índice</p>

        <ul>
          <li>
            <a href="#1">
              <span>
                <strong>1.</strong> Estrutura da Entrega
              </span>
            </a>
          </li>

          <li>
            <a href="#2">
              <span>
                <strong>2.</strong> Ciência do Cliente
              </span>
            </a>
          </li>

          <li>
            <a href="#3">
              <span>
                <strong>3.</strong> Aceite
              </span>
            </a>
          </li>
        </ul>
      </NavbarGroup>

      <Content>
        <h1 style={{ marginTop: 50 }}>Imersão NRF – NYC 2026/2027 – Termo de Ciência</h1>

        <p>Entrega em duas etapas.</p>

        <p>
          Este documento tem como objetivo formalizar a ciência do cliente contratante quanto ao
          formato de entrega do programa IMERSÃO NRF - NYC 2027, o qual é realizado em dois
          momentos distintos, conforme detalhado abaixo.
        </p>

        <p id="1">
          <strong>1. ESTRUTURA DA ENTREGA:</strong>
        </p>
        <p>
          1.1. O programa contratado é composto por entregáveis distribuídos em duas etapas
          complementares, cada uma correspondente a 30% (trinta por cento) e 70% (setenta por
          cento) do valor total do contrato/proposta:
        </p>

        <p>
          <strong>1.2. Etapa 1 — Preparação (30%) | Entrega até dezembro/2026 – Kick-off</strong>
        </p>
        <p>
          1.2.1. Contempla os itens preparatórios disponibilizados antes da viagem, com entrega
          prevista para dezembro/2026:
        </p>
        <ul>
          <li>
            Guia Prático do Participante (recomendações de hospedagem e informações logísticas)
          </li>
          <li>Kick-off e briefing preparatório com o grupo</li>
          <li>Ingresso oficial da NRF 2027 garantido</li>
          <li>Acesso à curadoria de conteúdo pré-evento</li>
          <li>Network</li>
        </ul>

        <p>
          <strong>1.3. Etapa 2 — Imersão (70%) | Imersão presencial em Nova York</strong>
        </p>
        <p>
          1.3.1. Contempla a experiência presencial em Nova York e os entregáveis consolidados
          durante e ao término do programa:
        </p>
        <ul>
          <li>6 dias de imersão em Nova York com curadoria especializada da NRF 2027</li>
          <li>Visitas exclusivas a empresas e lojas icônicas em Nova York</li>
          <li>
            Visita guiada à NRF 2027, com curadoria <strong>StartSe</strong> para aproveitar o
            melhor do evento
          </li>
          <li>Wrap-up NRF — encontros diários para consolidar os insights do evento</li>
          <li>Super Quarta — dia exclusivo pós-evento com frameworks práticos de aplicação</li>
          <li>Acesso gratuito ao Pós-NRF Online</li>
          <li>
            Certificação emitida pela <strong>StartSe</strong> University
          </li>
        </ul>

        <p id="2">
          <strong>2. CIÊNCIA DO CLIENTE:</strong>
        </p>
        <p>2.1. Ao aceitar este termo, o cliente declara estar ciente de que:</p>
        <ul>
          <li>
            A entrega do programa ocorre em dois momentos distintos: (i) dezembro/2026, referente
            à Etapa 1 — Preparação; e (ii) ao término da imersão internacional em Nova York,
            referente à Etapa 2 — Imersão;
          </li>
          <li>
            Cada etapa corresponde a 30% e 70% do total contratado, sendo esse percentual
            utilizado como referência para o reconhecimento da entrega do serviço ao longo do
            tempo;
          </li>
          <li>
            Os itens não inclusos no programa (passagens aéreas internacionais, hospedagem,
            alimentação (exceto snacks/bebidas do programa), visto e seguro viagem) permanecem sob
            responsabilidade do participante, conforme condições gerais do programa.
          </li>
        </ul>

        <p id="3">
          <strong>3. ACEITE:</strong>
        </p>
        <p>3.1. Declaro estar ciente e de acordo com o formato de entrega descrito neste termo.</p>
      </Content>
      <BackToTop />
    </Container>
  );
};

export default TermoCienciaNRF;
